import React from "react";
import SwitchCampos from "../../Vista/components/SwitchCampos";

function MapaInfo({ selectedElement, mapaInfo }) {

  return (
    <div
      id={mapaInfo.id_a + "_div"}
      style={{
        gridColumn: "span 12",
      }}
      className={`tarjeta_grid_item ${mapaInfo.className}`}
    >
      {mapaInfo.sc_hijos
        ?.filter((cab) => cab.componente !== "hidden")
        .sort((a, b) => a.orden - b.orden)
        .map((cab, i) => {
          return (
            <SwitchCampos
              key={cab.id_a}
              data={selectedElement}
              datos={selectedElement}
              cab={cab}
              id_elemento={cab.id_a + 1}
            />
          );
        })}
    </div>
  );
}

export default MapaInfo;
